import { useMemo } from 'react';

import { Tkv2PDF } from '../../tkv2PDF/types.ts';
import { buildPdfReportData } from '../builders/buildPdfReportData.ts';
import { useAppraisalReportData } from './useAppraisalReportData.tsx';

/**
 * Hook that returns only the PDF-specific data.
 * Use this when you only need PDF generation data.
 */
export const usePdfReportData = (): Tkv2PDF => {
  const coreData = useAppraisalReportData();

  return useMemo(() => buildPdfReportData(coreData), [coreData]);
};
